/*=========================================================================================
 File Name: store.js
 Description: Vuex store
 ----------------------------------------------------------------------------------------
 Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
 Author: Pixinvent
 Author URL: http://www.themeforest.net/user/pixinvent
 ==========================================================================================*/

import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import VuexSessionStorage from '../plugins/VuexPersistPlugin.js';
import actions from './actions';
import CRM_NAVIGATION from './CrmNavigationStore.js';
import FILTERS from './FiltersStore';
import getters from './getters';

import ACCOUNT from './modules/account';
import ADDRESS from './modules/address';
import AGREEMENT_MODULE from './modules/agreement';
import AUTH from './modules/auth';
import BOOKKEEPING_MODULE from './modules/bookkeeping';
import CHANGELOG_MODULE from './modules/changediary';
import CLIENT_AGREEMENT_MODULE from './modules/client_agreement';
import CLOSED_MONTH_MODULE from './modules/closed_month.js';
import COMPANY_ZUS from './modules/company_zus.js';
import CRM_MODULE from './modules/crm';
import DECLARATION_MODAL from './modules/declaration_modal.js';
import EVIDENCE_MODULE from './modules/evidence.js';
import FILES from './modules/files';
import FIXED_ASSET_MODULE from './modules/fixed_asset';
import GENERAL from './modules/general';
import INVOICE_DESCRIPTION_TPL_MODULE from './modules/invoice_description_template';
import LOADER from './modules/loader';
import OCR from './modules/ocr.js';
import POPUP from './modules/popup.js';
import PRICE_LIST from './modules/PriceListStore.js';
import PRINTER_MODULE from './modules/printer';
import SELECTED from './modules/selected';
import STAFF_MODULE from './modules/staff';
import SYSTEM_BALANCE from './modules/systemBalance.js';
import TABS from './modules/tabs';
import TODO_MODULE from './modules/todo';
import WEBSITE_MODULE from './modules/website.js';
import mutations from './mutations';
import state from './state';

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    ACCOUNT,
    ADDRESS,
    AGREEMENT_MODULE,
    auth: AUTH,
    BOOKKEEPING_MODULE,
    CHANGELOG_MODULE,
    CLIENT_AGREEMENT_MODULE,
    CLOSED_MONTH_MODULE,
    COMPANY_ZUS,
    CRM_MODULE,
    CRM_NAVIGATION,
    DECLARATION_MODAL,
    EVIDENCE_MODULE,
    FILES,
    FILTERS,
    FIXED_ASSET_MODULE,
    GENERAL,
    INVOICE_DESCRIPTION_TPL_MODULE,
    LOADER,
    OCR,
    POPUP,
    PRICE_LIST,
    PRINTER_MODULE,
    SELECTED,
    STAFF_MODULE,
    SYSTEM_BALANCE,
    TABS,
    TODO_MODULE,
    WEBSITE_MODULE,
  },
  plugins: [
    createPersistedState({ paths: ['auth'] }),
    VuexSessionStorage.plugin,
  ],
  strict: process.env.NODE_ENV !== 'production',
});
